import type { Icon } from 'types';

type Props = {
  fill?: string;
  stroke?: string;
} & Icon;

const SocialIcon = ({
  stroke = 'black',
  fill = 'black',
  width,
  height
}: Props) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="19" cy="5" r="3" stroke={stroke} strokeWidth="2" />
        <circle cx="19" cy="19" r="3" stroke={stroke} strokeWidth="2" />
        <circle cx="5" cy="12" r="3" stroke={stroke} strokeWidth="2" />
        <path
          fill={fill}
          d="m7.008 9.683 8.825-4.704.94 1.765-8.824 4.704zM7.824 13.075l9.059 4.235-.847 1.812-9.06-4.235z"
        />
      </svg>
    </>
  );
};

export default SocialIcon;
